var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.bought)?_c('button',{staticClass:"get-trial",class:_vm.extraClass,on:{"click":_vm.getTrial}},[_vm._v(" get a free trial ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }